import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { PublisherPortal } from '@/services/apis';

interface StateType {
  publishers?: any[];
  loading?: boolean;
  error?: boolean;
  errorMessage?: string;
  totalRecords?: number;
  organizationAdmins?: any[];
  totalOrganizationAdminsCount?: number;
}

const initialState: StateType = {
  publishers: [],
  loading: true,
  error: false,
  errorMessage: '',
  totalRecords: 0,
  organizationAdmins: [],
  totalOrganizationAdminsCount: 0
};

export const fetchPublisher = createAsyncThunk(
  'publisher/fetchPublisher',
  async ({ domainName, organizationName, page, rowsPerPage, applicationType, apiStatus, apiName }: any) => {
    const response = await PublisherPortal.fetchPublisher({
      domainName,
      organizationName,
      pageNumber: page,
      pageSize: rowsPerPage,
      applicationType: applicationType,
      apiStatus: apiStatus,
      apiName: apiName
    });
    return response;
  }
);

export const createNewApi = createAsyncThunk('publisher/createApi', async ({ path, apiData }: any) => {
  const data = await PublisherPortal.createPublisher(path, apiData);
  return data;
});

export const deletePublisherApi = createAsyncThunk('publisher/deleteApi', async (params: any) => {
  const data = await PublisherPortal.deletePublisher(params);
  return data;
});

export const fetchPublisherApiDetails = createAsyncThunk('publisher/fetchApiDetails', async (id: any) => {
  const response = await PublisherPortal.fetchApiDetails(id);
  return response;
});

export const updateApi = createAsyncThunk('publisher/updateApi', async (apiData: any) => {
  const { apiId, ...finalData } = apiData;
  const data = await PublisherPortal.updatePublisher(finalData, apiId);
  return data;
});

export const publishApi = createAsyncThunk('publisher/publishApi', async (body: any) => {
  const data = await PublisherPortal.publishApi(body);
  return data;
});

export const downloadOrganization = createAsyncThunk('organization/downloadOrganization', async () => {
  const response = await PublisherPortal.downloadPublisher();
  return response;
});

export const PublisherSlice = createSlice({
  name: 'organization',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchPublisher.pending, (state) => {});
    builder.addCase(fetchPublisher.fulfilled, (state, { payload }) => {
      return { ...state, organizations: payload?.result?.organizations, totalRecords: payload?.totalRecords, loading: false };
    });
    builder.addCase(fetchPublisher.rejected, (state) => {
      return { ...state, organizations: [], totalRecords: 0, loading: false };
    });
  }
});

export const organizationSelector = (state: any) => state.domain;

export default PublisherSlice.reducer;
